import AdminBoxConent from "../../components/admin/AdminBoxContent";
import Select from "react-select";
import UserTag from "../../models/userTag";
import { useEffect, useState } from "react";
import DropdownOption from "../../components/common/DropdownOption";
import userSyncService from "../../services/userSyncService";
import UserTagMappingModel from "../../models/userTagMapping";
import UserTagMappingType from "../../models/userTagMappingType";
import { useNavigate } from "react-router-dom";

const UserTagMapping: React.FC = () => {
  const navigate = useNavigate();

  const [userTagMappings, setUserTagMappings] = useState<UserTagMappingModel[]>(
    []
  );

  const [userTagOptions, setUserTagOptions] = useState<
    DropdownOption<UserTag>[]
  >([]);

  const userTagMappingTypes: UserTagMappingType[] = [
    UserTagMappingType.InvitationTag,
    UserTagMappingType.TrialSubscription90DayTag,
    UserTagMappingType.TrialSubscription1YearTag,
    UserTagMappingType.PaidSubscriptionTag,
  ];

  useEffect(() => {
    const init = async () => {
      const { data: userTagMappings } =
        await userSyncService.getUserTagMappings();

      setUserTagMappings(userTagMappings);

      const { data: userTags } = await userSyncService.getUserTags();

      const userTagOptions: DropdownOption<UserTag>[] = userTags.map((ut) => {
        return { value: ut, label: ut.tagName };
      });

      setUserTagOptions(userTagOptions);
    };

    init();
  }, []);

  const getDisplayValue = (userTagMappingType: UserTagMappingType) => {
    let displayValue = "";

    switch (userTagMappingType) {
      case UserTagMappingType.InvitationTag:
        displayValue = "Invitation Tag";
        break;

      case UserTagMappingType.TrialSubscription90DayTag:
        displayValue = "90 Day Trial Subscription Tag";
        break;

      case UserTagMappingType.TrialSubscription1YearTag:
        displayValue = "1 Year Trial Subscription Tag";
        break;

      case UserTagMappingType.PaidSubscriptionTag:
        displayValue = "Paid Subscription Tag";
        break;

      default:
        break;
    }

    return displayValue;
  };

  const getSelectedUserTagOption = (userTagMappingType: UserTagMappingType) => {
    const userTagMapping = userTagMappings.find(
      (m) => m.userTagMappingType === userTagMappingType
    );

    if (!userTagMapping) {
      return null;
    }

    const userTagOption: DropdownOption<UserTag> = {
      value: userTagMapping.userTag,
      label: userTagMapping.userTag.tagName,
    };

    return userTagOption;
  };

  const updateTagMappings = () => {
    const newUserTagMappings = [...userTagMappings];
    setUserTagMappings(newUserTagMappings);
  };

  const onSelectedUserTagOptionsChanged = async (
    option: DropdownOption<UserTag>,
    userTagMappingType: UserTagMappingType
  ) => {
    let userTagMapping = userTagMappings.find(
      (m) => m.userTagMappingType === userTagMappingType
    );

    if (!option) {
      if (userTagMapping) {
        const newUserTagMappings = userTagMappings.filter(
          (m) => m !== userTagMapping
        );
        setUserTagMappings(newUserTagMappings);
      }
    } else {
      if (!userTagMapping) {
        userTagMapping = new UserTagMappingModel();
        userTagMapping.userTagMappingType = userTagMappingType;

        userTagMappings.push(userTagMapping);
      }

      if (option.value) {
        userTagMapping.userTag = option.value;
        userTagMapping.idUserTag = userTagMapping.userTag.idUserTag;
      }

      updateTagMappings();
    }
  };

  const onSave = async () => {
    await userSyncService.saveUserTagMappings(userTagMappings);

    navigate("/admin/invitations");
  };

  const onCancel = () => {
    navigate("/admin/invitations");
  };

  return (
    <AdminBoxConent
      title="Tag Mapping"
      hasCount={false}
      hasAddNew={false}
      hasCurrentOrganizationDropdown={false}
    >
      <table style={{ borderCollapse: "separate", borderSpacing: "10px" }}>
        <tbody>
          {userTagMappingTypes.map((userTagMappingType, index) => (
            <tr key={index.toString()}>
              <td style={{ textWrap: "nowrap" }}>
                {getDisplayValue(userTagMappingType)}
              </td>
              <td style={{ width: "500px" }}>
                <Select
                  isClearable
                  options={userTagOptions}
                  value={getSelectedUserTagOption(userTagMappingType)}
                  onChange={(option: any) => {
                    onSelectedUserTagOptionsChanged(option, userTagMappingType);
                  }}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div>
        <button type="button" className="btn btn-primary" onClick={onSave}>
          Save
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          style={{ marginLeft: "10px" }}
          onClick={onCancel}
        >
          Cancel
        </button>
      </div>
    </AdminBoxConent>
  );
};

export default UserTagMapping;
